// extracted by mini-css-extract-plugin
export var prodSize = "style-mod--prod-size--0241f";
export var productContainer = "style-mod--product-container--4665c";
export var selected = "style-mod--selected--1c7ce";
export var switcherWithImages = "style-mod--switcher-with-images--206fa";
export var titleAndSize = "style-mod--title-and-size--eb28e";
export var variantBox = "style-mod--variant-box--20d48";
export var variantImg = "style-mod--variant-img--ec906";